import { Common } from "@secondcloset/types";
import { getAPIFromDomain } from "lib/api";

type OrgShippingConfig = Common.OrganizationShippingConfig;
interface OrganizationShippingConfigBody {
  organization_id: string;
  key: string;
  value: string[];
}

const endpoint = "organizations_shipping_configurations";

export const fetchShippingConfigurations = async (organization_id: string): Promise<OrgShippingConfig[]> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.get(`/${endpoint}/${organization_id}`);
  return res.data;
};

export const createShippingConfiguration = async (body: OrganizationShippingConfigBody): Promise<OrgShippingConfig> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.post(`/${endpoint}`, body);
  return res.data;
};

export const updateFreightcomCredentials = async (body: OrganizationShippingConfigBody): Promise<OrgShippingConfig> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.put(`/${endpoint}`, body);
  return res.data;
};

export const deleteFreightcomCredentials = async (organization_id: string): Promise<void> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.delete(`/${endpoint}/${organization_id}`);
  return res.data;
};
